import script from "./VList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VList.vue?vue&type=script&setup=true&lang=ts"

import "./VList.vue?vue&type=style&index=0&id=e909f4fa&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e909f4fa"]])

export default __exports__